module.exports = __webpack_public_path__ + "img/stamp1.879cc337.png";